import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';
import * as Sentry from '@sentry/react';

import theme from '../../../theme';

import koReactSocket from './../../koReactSocket';

import ExtReferenceWorkflow from './ExternalReferenceWorkflow';
import IntReferenceWorkflow from './IntReferenceWorkflow';
import LogicSetWorkflow from './LogicSetWorkflow';
import TableFilterMenu from './TableFilterMenu';
import TimeboxWorkflow from './TimeboxWorkflow';
import SpecGridInfoModal from './SpecGridInfoModal';

/**
 * Add Sentry for React
 * Replace this when CAT-RCKMS is fully React driven
 */

Sentry.init({
    dsn: process.env.SENTRY_DSN || undefined,
    environment: process.env.SENTRY_ENVIRONMENT || undefined,
    release: process.env.SENTRY_RELEASE || undefined
});

Sentry.setContext('rckms_module', {
    name: 'Reporting Specifications'
});

// Import workflow dependencies
window.React = React;
window.ReactDOM = ReactDOM;
window.koReactSocket = koReactSocket;

// Import all componenets
window.ExtReferenceWorkflow = ExtReferenceWorkflow;
window.IntReferenceWorkflow = IntReferenceWorkflow;
window.LogicSetWorkflow = LogicSetWorkflow;
window.TableFilterMenu = TableFilterMenu;
window.TimeboxWorkflow = TimeboxWorkflow;
window.SpecGridInfoModal = SpecGridInfoModal;
window.renderReactComponent = (Component, props, target) => {
    window.ReactDOM.render(
        <ThemeProvider theme={theme}>{React.createElement(Component, props)}</ThemeProvider>,
        target
    );
};
// ReactDOM.render(<ExtReferenceWorkflow />, document.getElementById('ext-links-references-workflow-index'));
